import log from "../../../utils/logger/library";

export const goalSendError = new Error("Failed to send goal");
export const goalResponseError = new Error(
    "Failed to send goal status not 200"
);
export const selectedItemGoalError = new Error("Failed in selecting item goal");

const responseHandler = (resp) => {
    if (resp.status !== 200) {
        log.error("(responseHandler) UserSplitTest", goalResponseError);
    }
};

/**
 * @param code {string} conductrics api code
 * @return void
 */

export const sendGoal = (code) => {
    try {
        if (!window.CBC.APP.AB.Testing.sendGoal(code, 1, responseHandler)) {
            log.error("(sendGoal) UserSplitTest", goalSendError);
        }
    } catch (error) {
        log.error("(sendGoal) UserSplitTest", goalSendError);
    }
};

export const FireCustomGoal = (selectors, goalID) => (event) => {
    try {
        event.target.closest(selectors) && sendGoal(goalID);
    } catch (error) {
        log.error(
            "(FireCustomGoal) UserSplitTest",
            new Error("Failed in firing custom goal")
        );
    }
};

export const SelectedItemGoal = (selectors) => (event) => {
    try {
        event.target.closest(selectors) && sendGoal("api-selected-item");
    } catch (error) {
        log.error("(SelectedItemGoal) UserSplitTest", selectedItemGoalError);
    }
};
